import { render, staticRenderFns } from "./bannerEditor.vue?vue&type=template&id=0cca6da5&"
import script from "./bannerEditor.vue?vue&type=script&lang=js&"
export * from "./bannerEditor.vue?vue&type=script&lang=js&"
import style0 from "./bannerEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports